<div mat-dialog-title>
  <h2>{{ title }}</h2>
  <button
    matIconButton
    class="close-btn"
    [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div
  mat-dialog-content
  class="mat-typography">
  <form [formGroup]="termForm">
    <div class="form-group">
      <mat-form-field class="full-width">
        <input
          matInput
          formControlName="termName"
          placeholder="Enter name" />
        @if (termForm.get('name')?.hasError('required')) {
          <mat-error>Name is required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-group">
      <mat-form-field class="full-width">
        <input
          matInput
          type="number"
          formControlName="relevance"
          placeholder="Enter relevance" />
        @if (termForm.get('relevance')?.hasError('required')) {
          <mat-error>Relevance is required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="m-b">
      <mat-slide-toggle formControlName="isGlobal">Global</mat-slide-toggle>
    </div>
    <h4>Term file</h4>
    <div class="file__container">
      <button
        [ngClass]="{ 'file-selected': fileSelected }"
        matButton="outlined"
        class="primary-button">
        <mat-icon fontSet="material-symbols-outlined">upload</mat-icon>
        <label for="uploadTermFile">Upload File</label>
      </button>
      <input
        type="file"
        name="policyFileName"
        id="uploadTermFile"
        (change)="onFileSelected($event)"
        [disabled]="fileSelected" />

      @if (fileSelected) {
        <div>
          <div class="file">
            {{ file?.name || currentTerm.file?.filename }}
            <button
              matIconButton
              class="file__remove"
              (click)="removeFile()">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </div>
      }
    </div>
  </form>
</div>

<div
  mat-dialog-actions
  align="end">
  <button
    matButton
    [mat-dialog-close]="false">
    Cancel
  </button>
  <button
    matButton="filled"
    class="primary-button"
    [disabled]="termForm.invalid || !fileSelected"
    (click)="save()">
    save
  </button>
</div>
